(() => {
  const mounted = new Map();
  function mount(home) {
    if (mounted.has(home)) return;
    const abort = new AbortController();
    const tabs = [...home.querySelectorAll('[data-category]')];
    const panels = [...home.querySelectorAll('[data-panel]')];
    const navigation = home.querySelector('.gk-tabs');
    const mobile = matchMedia('(max-width: 700px)');
    const accordions = [...home.querySelectorAll('[data-accordion]')];
    const groups = panels.map(panel => ({panel, heading:panel.previousElementSibling}));
    let desktopCategory = 'eud';
    const openCategories = new Set(['eud', 'command']);
    function orderGroups(category) {
      let cursor = navigation;
      const ordered = category ? [...groups.filter(group => group.panel.dataset.panel === category), ...groups.filter(group => group.panel.dataset.panel !== category)] : groups;
      ordered.forEach(({heading, panel}) => {
        if (cursor.nextElementSibling !== heading) cursor.after(heading);
        if (heading.nextElementSibling !== panel) heading.after(panel);
        cursor = panel;
      });
    }
    let frame = 0;
    function applyMode() {
      orderGroups(mobile.matches ? null : desktopCategory);
      panels.forEach(panel => {
        const open = !mobile.matches || openCategories.has(panel.dataset.panel);
        panel.hidden = !open;
        panel.setAttribute('aria-labelledby', (mobile.matches ? 'gk-accordion-' : 'gk-tab-') + panel.dataset.panel);
      });
      accordions.forEach(button => {
        const open = !mobile.matches || openCategories.has(button.dataset.accordion);
        button.setAttribute('aria-expanded', String(open));
        button.querySelector('.gk-accordion-icon').textContent = open ? '−' : '+';
      });
      window.ScrollTrigger?.refresh();
    }
    mobile.addEventListener('change', applyMode, {signal:abort.signal});
    function highlight(category) {
      const selected = tabs.find(tab => tab.dataset.category === category);
      const changed = selected?.getAttribute('aria-current') !== 'true';
      tabs.forEach(tab => tab.setAttribute('aria-current', String(tab.dataset.category === category)));
      if (changed && selected && navigation.scrollWidth > navigation.clientWidth) {
        const item = selected.getBoundingClientRect(), bar = navigation.getBoundingClientRect();
        if (item.left < bar.left || item.right > bar.right) navigation.scrollTo({left:navigation.scrollLeft + item.left - bar.left, behavior:'instant'});
      }
    }
    function track() {
      frame = 0;
      if (mobile.matches) return;
      const threshold = navigation.getBoundingClientRect().height + 36;
      const orderedPanels = [...home.querySelectorAll('[data-panel]')];
      let active = orderedPanels[0];
      orderedPanels.forEach(panel => { if (panel.getBoundingClientRect().top <= threshold) active = panel; });
      if (active) highlight(active.dataset.panel);
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(track); }
    function jump(category, focus = false, navigate = false) {
      const panel = panels.find(p => p.dataset.panel === category);
      if (!panel) return;
      if (mobile.matches) {
        openCategories.add(category);
        applyMode();
        home.querySelector('[data-accordion="' + category + '"]').scrollIntoView({behavior:'instant',block:'start'});
        return;
      }
      if (focus) tabs.find(tab => tab.dataset.category === category)?.focus({preventScroll:true});
      desktopCategory = category;
      orderGroups(category);
      highlight(category);
      // Category buttons reorder in place. Links elsewhere still lead to the catalogue.
      if (navigate) navigation.scrollIntoView({behavior:'instant',block:'start'});
    }
    home.addEventListener('click', event => {
      const accordion = event.target.closest('[data-accordion]');
      if (accordion && mobile.matches) {
        const before = accordion.getBoundingClientRect().top;
        const category = accordion.dataset.accordion;
        if (openCategories.has(category)) openCategories.delete(category);
        else openCategories.add(category);
        applyMode();
        window.scrollBy({top:accordion.getBoundingClientRect().top - before,behavior:'instant'});
        return;
      }
      const tab = event.target.closest('[data-category]');
      const link = event.target.closest('[data-category-link]');
      if (tab || link) { event.preventDefault(); jump(tab ? tab.dataset.category : link.dataset.categoryLink, false, Boolean(link)); }
    }, {signal:abort.signal});
    navigation.addEventListener('keydown', event => {
      const current = tabs.indexOf(document.activeElement); if (current < 0) return;
      let next;
      if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (current + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); jump(tabs[next].dataset.category, true); }
    }, {signal:abort.signal});
    window.addEventListener('scroll', schedule, {passive:true,signal:abort.signal});
    window.addEventListener('resize', schedule, {passive:true,signal:abort.signal});
    const linkedCategory = panels.find(panel => '#' + panel.id === location.hash)?.dataset.panel;
    if (linkedCategory) openCategories.add(linkedCategory);
    applyMode();
    window.addEventListener('hashchange', () => {
      const panel = panels.find(panel => '#' + panel.id === location.hash);
      if (panel) jump(panel.dataset.panel);
    }, {signal:abort.signal});
    track();
    let mm;
    if (window.gsap && window.ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
      mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        gsap.fromTo(home.querySelector('.gk-hero-image'), {scale:1.045}, {scale:1,ease:'none',scrollTrigger:{trigger:home.querySelector('.gk-hero'),start:'top top',end:'bottom top',scrub:1,id:'gotak-field-hero'}});
        gsap.from(home.querySelector('.gk-system-image img'), {scale:1.035,duration:1.4,ease:'power2.out',scrollTrigger:{trigger:home.querySelector('.gk-system'),start:'top 75%',once:true}});
      },home);
    }
    const refresh = () => { window.ScrollTrigger?.refresh(); schedule(); };
    home.querySelectorAll('img').forEach(img => { if (!img.complete) img.addEventListener('load', refresh, {once:true,signal:abort.signal}); });
    mounted.set(home, () => { abort.abort(); cancelAnimationFrame(frame); mm?.revert(); mounted.delete(home); });
  }
  document.querySelectorAll('[data-field-home]').forEach(mount);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-field-home]').forEach(mount));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-field-home]').forEach(home => mounted.get(home)?.()));
})();
